import React from 'react';
import { Link } from 'react-router-dom';


const Mercury = () => {
	return (
<>
<p><Link to="/">Home</Link></p>
<h1>Mercury</h1>
<img alt="Planet Mercury Mythology" src="https://upload.wikimedia.org/wikipedia/commons/4/4a/Mercury_in_true_color.jpg" style={{"width":"200px","margin-top":"10px"}}/>

<p className="godLink"><a href="https://en.wikipedia.org/wiki/Hermes" >Budha - Hindu</a></p>
<p className="godDescription">A benevolent but minor male deity with light yellow colored (or green) body, draped into yellow clothes, holding a scimitar, a club, and a shield. He is canonically represented riding a chariot made of air and fire, drawn by eight wind horses; but in some illustrations, he rides a lion and has four arms, and in <a href="https://en.wikipedia.org/wiki/Swetharanyeswarar_Temple">Bhudhan Temple</a> he is depicted riding a winged lion.</p>

<p className="godLink"><a href="https://en.wikipedia.org/wiki/Hermes" >Hermes - Greek</a></p>
<p className="godDescription">Considered the herald of the gods. He is also considered the protector of human heralds, travellers, thieves, merchants, and orators. He is able to <a href="https://en.wikipedia.org/wiki/Liminal_deity">move quickly and freely between the worlds of the mortal and the divine</a>, aided by his winged sandals.</p>

<p className="godLink"><a href="https://en.wikipedia.org/wiki/Mercury_(mythology)" >Mercury - Roman</a></p>
<p className="godDescription">The god of financial gain, commerce, eloquence, messages, communication (including divination), travelers, boundaries, luck, trickery and thieves; he also serves as the <a href="https://en.wikipedia.org/wiki/Psychopomp">guide of souls to the underworld</a>.</p>

<p className="godLink"><a href="https://en.wikipedia.org/wiki/Hermes" >Moccus - Celtic</a></p>
<p className="godDescription">Invoked as the protector of boar hunters and warriors.</p>

<p className="godLink"><a href="https://en.wikipedia.org/wiki/Thoth" >Thoth - Egyptian</a></p>
<p className="godDescription">Often depicted as a man with the head of an ibis or a baboon, animals sacred to him. God of the moon, wisdom, writing, hieroglyphs, science, magic, art, and judgment. </p>

<p className="godLink"><a href="https://en.wikipedia.org/wiki/Turms" >Turms - Etruscan</a></p>
<p className="godDescription">God of trade and the messenger god between people and gods.</p>
</>
)
}

export default Mercury;